<template>
    <button
        v-tippy="t('editorToggleHeader4')"
        :class="[
            buttonState(
                editor.can().toggleHeading({ level: 4 }),
                editor.isActive('heading', { level: 4 }),
            ),
            'flex-none rounded p-1 text-sm',
        ]"
        :disabled="!editor.can().toggleHeading({ level: 4 })"
        @click="editor.chain().focus().toggleHeading({ level: 4 }).run()"
    >
        <MdiFormatHeader4 class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiFormatHeader4 from 'materialdesignicons-vue3/icons/MdiFormatHeader4.js';

    defineExpose({
        name: 'FormatHeader4Button',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
